// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// IPoolAddressesProvider https://sonicscan.org/address/0x5C2e738F6E27bCE0F7558051Bf90605dD6176900
export const POOL_ADDRESSES_PROVIDER = '0x5C2e738F6E27bCE0F7558051Bf90605dD6176900';

// IPool https://sonicscan.org/address/0x5362dBb1e601abF3a4c14c22ffEdA64042E5eAA3
export const POOL = '0x5362dBb1e601abF3a4c14c22ffEdA64042E5eAA3';

// IPoolConfigurator https://sonicscan.org/address/0x50c70FEB95aBC1A92FC30b9aCc41Bd349E5dE2f0
export const POOL_CONFIGURATOR = '0x50c70FEB95aBC1A92FC30b9aCc41Bd349E5dE2f0';

// IAaveOracle https://sonicscan.org/address/0xD63f7658C66B2934Bd234D79D06aEF5290734B30
export const ORACLE = '0xD63f7658C66B2934Bd234D79D06aEF5290734B30';

// https://sonicscan.org/address/0x7b62461a3570c6AC8a9f8330421576e417B71EE7
export const ACL_ADMIN = '0x7b62461a3570c6AC8a9f8330421576e417B71EE7';

// IACLManager https://sonicscan.org/address/0x3a790a47c4d531FD333FAD24f70B0ccb521B3b5A
export const ACL_MANAGER = '0x3a790a47c4d531FD333FAD24f70B0ccb521B3b5A';

// IPoolDataProvider https://sonicscan.org/address/0xc0a344397cfa89dF1e1d3e4fb330834D789cF2CD
export const AAVE_PROTOCOL_DATA_PROVIDER = '0xc0a344397cfa89dF1e1d3e4fb330834D789cF2CD';

// https://sonicscan.org/address/0xF91D16F9b7Cd2488e699f95E8BcEc34E64283138
export const POOL_IMPL = '0xF91D16F9b7Cd2488e699f95E8BcEc34E64283138';

// https://sonicscan.org/address/0x6fDdde45f777a4E461B0721a578b169b44579623
export const POOL_CONFIGURATOR_IMPL = '0x6fDdde45f777a4E461B0721a578b169b44579623';

// https://sonicscan.org/address/0x24bD6e9ca54F1737467DEf82dCA9702925B3Aa59
export const DEFAULT_INCENTIVES_CONTROLLER = '0x24bD6e9ca54F1737467DEf82dCA9702925B3Aa59';

// https://sonicscan.org/address/0xd3A0A19Cdb7d1615f30988763BEA5f8feCc17a87
export const EMISSION_MANAGER = '0xd3A0A19Cdb7d1615f30988763BEA5f8feCc17a87';

// ICollector https://sonicscan.org/address/0x1aB55bBdD5DF0782BBCf73553Af93BC6B29A286B
export const COLLECTOR = '0x1aB55bBdD5DF0782BBCf73553Af93BC6B29A286B';

// https://sonicscan.org/address/0x9E7A2eD2da913Cf5608256Bd7114dF3fC3a24a78
export const DEFAULT_A_TOKEN_IMPL = '0x9E7A2eD2da913Cf5608256Bd7114dF3fC3a24a78';

// https://sonicscan.org/address/0x2022597abeE8007bbf4E72f51Fc1B5493363AcA6
export const DEFAULT_VARIABLE_DEBT_TOKEN_IMPL = '0x2022597abeE8007bbf4E72f51Fc1B5493363AcA6';

// https://sonicscan.org/address/0x29081f7aB5a644716EfcDC10D5c926c5fEe9F72B
export const CONFIG_ENGINE = '0x29081f7aB5a644716EfcDC10D5c926c5fEe9F72B';

// https://sonicscan.org/address/0xdb93e2712a8B36835078f8D28c70fCC95FD6d37c
export const RISK_STEWARD = '0xdb93e2712a8B36835078f8D28c70fCC95FD6d37c';

// https://sonicscan.org/address/0x5E5D87858592d211fdb4503F09FB2B5cf805cB51
export const POOL_ADDRESSES_PROVIDER_REGISTRY = '0x5E5D87858592d211fdb4503F09FB2B5cf805cB51';

// https://sonicscan.org/address/0xeC859AED64e87004FA724892D5aB474901825B2D
export const UI_INCENTIVE_DATA_PROVIDER = '0xeC859AED64e87004FA724892D5aB474901825B2D';

// https://sonicscan.org/address/0x4F3F69979ED28c962028582B1760E98B1a117097
export const UI_POOL_DATA_PROVIDER = '0x4F3F69979ED28c962028582B1760E98B1a117097';

// https://sonicscan.org/address/0x6637Ef9c6b41Fa62d69b7E88C5Dd9eF30BbEE945
export const WALLET_BALANCE_PROVIDER = '0x6637Ef9c6b41Fa62d69b7E88C5Dd9eF30BbEE945';

// https://sonicscan.org/address/0x061D8e131F26512348ee5FA42e2DF1bA9d6505E9
export const WETH_GATEWAY = '0x061D8e131F26512348ee5FA42e2DF1bA9d6505E9';

// https://sonicscan.org/address/0xFeeb6FE430B7523fEF2a38327241eE7153779535
export const STATA_FACTORY = '0xFeeb6FE430B7523fEF2a38327241eE7153779535';

// https://sonicscan.org/address/0x62aDD9C6B511085C67515ebB799b51c4cf2d786F
export const DUST_BIN = '0x62aDD9C6B511085C67515ebB799b51c4cf2d786F';

// https://sonicscan.org/address/0x4A137d528444Cc0346320CFa5C80FFc68087D7F9
export const POOL_EXPOSURE_STEWARD = '0x4A137d528444Cc0346320CFa5C80FFc68087D7F9';

// https://sonicscan.org/address/0x5598BbFA2f4fE8151f45bBA0a3edE1b54B51a0a9
export const REPAY_WITH_COLLATERAL_ADAPTER = '0x5598BbFA2f4fE8151f45bBA0a3edE1b54B51a0a9';

// https://sonicscan.org/address/0x78F8Bd884C3D738B74B420540659c82f392820e0
export const SWAP_COLLATERAL_ADAPTER = '0x78F8Bd884C3D738B74B420540659c82f392820e0';

// https://sonicscan.org/address/0x2E549104c516b8657A7D888494DfbAbD7C70b464
export const DEBT_SWAP_ADAPTER = '0x2E549104c516b8657A7D888494DfbAbD7C70b464';

// https://sonicscan.org/address/0x5d4D4007A4c6336550DdAa2a7c0d5e7972eebd16
export const WITHDRAW_SWAP_ADAPTER = '0x5d4D4007A4c6336550DdAa2a7c0d5e7972eebd16';

export const CHAIN_ID = 146;
export const ASSETS = {
  WETH: {
    decimals: 18,
    id: 0,
    UNDERLYING: '0x50c42dEAcD8Fc9773493ED674b675bE577f2634b',
    A_TOKEN: '0xe18Ab82c81E7Eecff32B8A82B1b7d2d23F1EcE96',
    V_TOKEN: '0x07B1adFB7d5795Cf21baE8a77Eceb222F2FafBCE',
    INTEREST_RATE_STRATEGY: '0xdFf435BCcf782f11187D3a4454d96702eD78e092',
    ORACLE: '0x824364077993847f71293B24ccA8567c00c2de11',
    STATA_TOKEN: '0xeB5e9B0ae5bb60274786C747A1A2A798c11271E0',
  },
  USDC: {
    decimals: 6,
    id: 1,
    UNDERLYING: '0x29219dd400f2Bf60E5a23d13Be72B486D4038894',
    A_TOKEN: '0x578Ee1ca3a8E1b54554Da1Bf7C583506C4CD11c6',
    V_TOKEN: '0x2273caBAd63b7D247A6b107E723c803fc49953A0',
    INTEREST_RATE_STRATEGY: '0xdFf435BCcf782f11187D3a4454d96702eD78e092',
    ORACLE: '0x7A8443a2a5D772db7f1E40DeFe32db485108F128',
    STATA_TOKEN: '0x6646248971427B80ce531bdD793e2Eb859347E55',
  },
  wS: {
    decimals: 18,
    id: 2,
    UNDERLYING: '0x039e2fB66102314Ce7b64Ce5Ce3E5183bc94aD38',
    A_TOKEN: '0x6C5E14A212c1C3e4Baf6f871ac9B1a969918c131',
    V_TOKEN: '0xF6089B790Fbf8F4812a79a31CFAbeB00B06BA7BD',
    INTEREST_RATE_STRATEGY: '0xdFf435BCcf782f11187D3a4454d96702eD78e092',
    ORACLE: '0xc76dFb89fF298145b417d221B2c747d84952e01d',
    STATA_TOKEN: '0x18B7B8695165290f2767BC63c36D3dFEa4C0F9bB',
  },
  stS: {
    decimals: 18,
    id: 3,
    UNDERLYING: '0xE5DA20F15420aD15DE0fa650600aFc998bbE3955',
    A_TOKEN: '0xeAa74D7F42267eB907092AF4Bc700f667EeD0B8B',
    V_TOKEN: '0x333cFdCB6457C409e4f0C88F3806252bEe5fe425',
    INTEREST_RATE_STRATEGY: '0xdFf435BCcf782f11187D3a4454d96702eD78e092',
    ORACLE: '0x5BA5D5213B47DFE020B1F8d6fB54Db3F74F9ea9a',
  },
} as const;
export const E_MODES = {
  '1': {
    label: 'stS / wS',
    collateralBitmap: '8',
    collateralAssets: ['0xE5DA20F15420aD15DE0fa650600aFc998bbE3955'],
    borrowableBitmap: '4',
    borrowableAssets: ['0x039e2fB66102314Ce7b64Ce5Ce3E5183bc94aD38'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 8700,
    liquidationThreshold: 9000,
    liquidationBonus: 10100,
  },
} as const;
export const EXTERNAL_LIBRARIES = {
  FLASHLOAN_LOGIC: '0xE66AdcF153d0bD67a74e5d23e23F90b4011024EC',
  BORROW_LOGIC: '0x1Fb8f7C906cddD28B42ae6Eb76abC04A91188635',
  LIQUIDATION_LOGIC: '0x8dc095F287dBEBD9e15f75BB3DfBF18389BB8104',
  POOL_LOGIC: '0x25Ed699a052B820d772765E26Ed4dD9f0A26F3E5',
  SUPPLY_LOGIC: '0x33654b16A4De97bCE05d7dD06803Bf1066f3123C',
} as const;
